module.exports = __webpack_public_path__ + "img/9Y.9d0adfef.png";